"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.email.contacts': 'Kontakty',
    'whatsapp.email.noContacts': 'Nie znaleziono kontaktów e-mail.',
    'whatsapp.email.loadFailed': 'Nie udało się załadować kontaktów e-mail.',
    'whatsapp.email.stats.contacts': 'Kontakty',
    'whatsapp.email.stats.total': 'Łącznie',
    'whatsapp.email.trackLogs': 'Logi śledzenia',
    'whatsapp.email.noLogs': 'Brak logów śledzenia.',
};
